module.exports = __webpack_public_path__ + "static/media/other-notification.d24014cc.svg";